import React from "react";
import { useState, useEffect } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";

import { DataGrid } from "@mui/x-data-grid";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DemoPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: "left",
}));

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
}));

export default function Products() {
  const [dense, setDense] = useState(false);

  // Grid Data

  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "prod_name",
      headerName: "Name",
      editable: true,
    },
    {
      field: "prod_price",
      headerName: "Features",
      editable: true,
    },
    {
      field: "prod_sale",
      headerName: "Sale Price",
      editable: true,
    },
    {
      field: "prod_stock",
      headerName: "Stock",
      editable: true,
    },

    {
      field: "prod_features",
      headerName: "Product Features",
      editable: true,
    },
    {
      field: "prod_desc",
      headerName: "Description",
      editable: true,
    },
    {
      field: "prod_expiry",
      headerName: "Expiry",
      // type: 'number',
      editable: true,
    },
    {
      field: "prod_var",
      headerName: "Variation",
      editable: true,
    },
    {
      field: "prod_category",
      headerName: "Category",
      editable: true,
    },
    {
      field: "prod_collection",
      headerName: "Collection",
      editable: true,
    },
    {
      field: "prod_popular",
      headerName: "Popular",
      editable: true,
    },

    // {
    //   field: 'prod_var',
    //   headerName: 'Product Variation',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // },
  ];

  const rows = [
    { id: 1, lastName: "Snow", firstName: "Jon", age: 14 },
    { id: 2, lastName: "Lannister", firstName: "Cersei", age: 31 },
    { id: 3, lastName: "Lannister", firstName: "Jaime", age: 31 },
    { id: 4, lastName: "Stark", firstName: "Arya", age: 11 },
    { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: null },
    { id: 6, lastName: "Melisandre", firstName: null, age: 150 },
    { id: 7, lastName: "Clifford", firstName: "Ferrara", age: 44 },
    { id: 8, lastName: "Frances", firstName: "Rossini", age: 36 },
    { id: 9, lastName: "Roxie", firstName: "Harvey", age: 65 },
  ];

  return (
    <div className="AddProducts">
      <Stack direction="column">
        <DemoPaper variant="outlined">
          {" "}
          <Stack direction="column" spacing={0}>
            {" "}
            <Stack
              direction="row"
              alignItems="flex-end"
              justifyContent="space-between"
            >
              <Container>
                <h2>Orders</h2>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" href="/">
                    MUI
                  </Link>
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/material-ui/getting-started/installation/"
                  >
                    Core
                  </Link>
                  <Link
                    underline="hover"
                    color="text.primary"
                    href="/material-ui/react-breadcrumbs/"
                    aria-current="page"
                  >
                    Breadcrumbs
                  </Link>
                </Breadcrumbs>
              </Container>{" "}
            </Stack>
          </Stack>
        </DemoPaper>
      </Stack>

      <Grid container sx={{ width: "100%" }}>
        <Box
          sx={{
            height: "450px",
            width: "calc(100% )",
            backgroundColor: "#fff",
          }}
        >
          {" "}
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </Grid>
    </div>
  );
}
